<template>
  <div class="tva-viz-mosaico-component">
    <div class="tile" v-for="(tile, tileIndex) in content" :key="tileIndex">
      <img v-if="tile.img" :src="`${baseUrl}images/${tile.img}.png`">
      <h6>{{tile.text}}</h6>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
.tva-viz-mosaico-component {
  max-width: 830px;
  margin: 0 auto;
  height: 700px;
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  .tile {
    width: calc((100% / 4) - 20px);
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    margin: 10px;
    padding: 20px !important;
    border-radius: 10px;
    -webkit-box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
    -moz-box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
    box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
    h6 {
      font-size: 16px;
      line-height: 26px;
      &::first-letter {
        padding-left: 7px;
        border-left: solid 2px $eni-yellow;
      }
    }
    img {
      width: 100%;
      margin-bottom: 30px;
      flex-shrink: 0;
    }
  }
}
@media (max-width: 1024px) {
  .tva-viz-mosaico-component {
    height: auto;
    flex-direction: row;
    padding: 0 50px;
    .tile {
      width: calc((100% / 2) - 20px);
      img {
        width: 40%;
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-viz-mosaico-component {
    padding: 0 20px;
    .tile {
      width: calc(100% - 20px);
      img {
        width: 70%;
      }
    }
  }
}
</style>

